export const siteConfig = {
  name: 'ReactTogether',
  url: 'https://reacttogether.io',
  ogImage: '',
  description: '(somewhat) Easily turn any react component into a connected experience',
  links: {
    multisynq: 'https://multisynq.io',
    twitter: 'https://x.com/multisynq',
    github: 'https://github.com/multisynq',
    croquet: 'https://croquet.io',
    // github: 'https://github.com/multisynq/reacttogether',
  },
}
